<script setup>
import { useUserStore } from '@/stores/user'
import { useRouter, useRoute} from 'vue-router'
const userStore = useUserStore()
import { useMainStore } from '@/stores/main'
let mainStore = useMainStore()

import { onMounted,ref } from 'vue'
import Slideover from '../../../components/SlideOver/slideover.vue'
import CreateForm from '../../../components/SlideOver/forms/CreateApiKey.vue'
import User from '../../../api/User';
import moment from 'moment'
import Card from '../../../components/Card.vue'
import Headline from '@/components/Blocks/Typo/Headline.vue'

let router = useRouter()

const keys = ref([])

onMounted(async () => {
  await userStore.details()
})

</script>

<template>
  <div class="container pt-5">
    <Headline title="Account" class="mb-5" />

    <!-- Tab Navigation -->
    <div class="tabs-header">
      <router-link
        to="/account"
        class="tab-button"
        exact-active-class="active"
      >
        <font-awesome-icon :icon="['fas', 'circle-user']" />
        Information
      </router-link>
      <router-link
        to="/account/apikeys"
        class="tab-button"
        active-class="active"
      >
        <font-awesome-icon :icon="['fas', 'key']" />
        API Keys
      </router-link>
    </div>

    <!-- Router view shows the correct page -->
    <div class="router-content">
      <router-view/>
    </div>

  </div>
</template>

<style scoped>
/* Container fills full viewport height */
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* Tab navigation - fixed, does not flex */
.tabs-header {
  flex-shrink: 0;
  display: flex;
  gap: 0.5rem;
  padding: 0;
  margin-bottom: 2rem;
  border-bottom: 2px solid rgba(255, 255, 255, 0.05);
}

.tab-button {
  background: none;
  border: none;
  color: #6B7280;
  font-size: 0.95rem;
  font-weight: 500;
  padding: 0.75rem 1rem;
  cursor: pointer;
  position: relative;
  transition: all 0.2s;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.tab-button:hover {
  color: #9CA3AF;
}

.tab-button.active {
  color: #a855f7;
  border-bottom-color: #a855f7;
}

.tab-button.active:hover {
  color: #b87ff8;
}

/* Router content area */
.router-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
</style>
